module.exports = __webpack_public_path__ + "static/img/3408_phase_function_Paper_Points.f9d7b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3408_phase_function_Paper_Points.png
// module id = /HFg
// module chunks = 0